/** Box 5 of the ICS 205A-CG, the Communications Unit Leader's Prepared by. */

import type React from 'react';

import { IcsPreparedByBox } from '../IcsPreparedByBox';
import { ICS205A_BOX_LABELS } from './ics205aBoxLabels';

export const Ics205aSignatureBox: React.FC<{ periodNumber: number }> = ({
  periodNumber,
}) => (
  <IcsPreparedByBox
    baseId="ICS_205A"
    periodNumber={periodNumber}
    boxLabel={ICS205A_BOX_LABELS.preparedBy}
    testId="ics205a-signature-box"
  />
);

export default Ics205aSignatureBox;
